import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
export const string = Yup.string();

export const createSchema = (shape) =>
  yupResolver(Yup.object().shape(shape));

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
const letterOnlyRegex =
  /^[a-zA-Z]+(-[a-zA-Z]+)?( (?! )[a-zA-Z]+(-[a-zA-Z]+)?)*$/;

export const passwordSchema = Yup.string()
  .required('errors:password.required')
  .matches(passwordRegex, 'errors:password.invalid');

export const emailSchema = string.trim().email('errors:email.invalid');
export const streetSchema = Yup.string().nullable();
export const apartmentSchema = Yup.string().nullable();
export const countrySchema = Yup.string().nullable();
export const addressSchema = Yup.string().nullable();
export const citySchema = Yup.string().nullable();
export const zipCodeSchema = Yup.string();
export const firstNameSchema = Yup.string()
  .nullable()
  .required('errors:first_name.required')
  .matches(/^[A-Z]/, 'errors:start.uppercase.validation')
  .min(3, 'errors:min.letters.first_name')
  .matches(letterOnlyRegex, 'errors:only.letters.allowed')
  .trim();

export const lastNameSchema = Yup.string()
  .nullable()
  .required('errors:last_name.required')
  .matches(/^[A-Z]/, 'errors:start.uppercase.validation')
  .min(3, 'errors:min.letters.last_name')
  .matches(letterOnlyRegex, 'errors:only.letters.allowed')
  .trim();

export const phoneSchema = Yup.string()
  .matches(/^\d{7,}$/, 'errors:phone.invalid')
  .required('errors:phone.required');

export const passwordMatchSchema = (password) =>
  Yup.string().oneOf(
    [Yup.ref(password), null],
    'errors:password.does.not.match',
  );


export const exampleForSelectComponent = Yup.string()
  .oneOf(
    [
      'FEW_HOURS',
      'FEW_MONTHS',
      'FEW_WEEKS',
      'NOT_SURE_HOW_LONG',
      'ONE_MONTH',
      'ONE_WEEK',
    ],
    'required field',
  )
  .nullable();

export const consignorNameSchema = Yup.string()
export const pickupPhoneNumberSchema = Yup.string()
export const pickupStreetNumberSchema = Yup.string()
export const pickupStreetNameSchema = Yup.string()
export const pickupUnitSchema = Yup.string()
export const pickupCitySchema = Yup.string()
export const pickupProvinceSchema = Yup.string()
export const pickupCountrySchema = Yup.string()
export const pickupPostalCodeSchema = Yup.string()
export const dropoffStreetNumberSchema = Yup.string()
export const dropoffStreetNameSchema = Yup.string()
export const dropoffPhoneNumberSchema = Yup.string()
export const dropoffUnitSchema = Yup.string()
export const dropOffCitySchema = Yup.string()
export const dropoffProvinceSchema = Yup.string()
export const dropoffCountrySchema = Yup.string()
export const dropoffPostalCodeSchema = Yup.string()
export const dropoffOpeningTimeSchema = Yup.string()
export const dropoffClosingTimeSchema = Yup.string()
export const customerSchema = Yup.string()
export const vehicleSchema = Yup.string()
export const serviceSchema = Yup.string()
export const pcsSchema = Yup.string()
export const spotSchema = Yup.string()
export const weightSchema = Yup.string()
export const weightTypeIdSchema = Yup.string()
export const ftSchema = Yup.string()
export const dimWgtSchema = Yup.string()
export const referenceSchema = Yup.string()